(function (root) {
  const finishes = ['All Black', 'Black / Milled', 'Chrome / Polished', 'Silver / Machined', 'Grey / Gunmetal', 'Bronze', 'Gold', 'Red', 'Blue', 'Green', 'White', 'Sand / Tan'];
  const fields = ['size', 'width', 'offset', 'finish', 'brand'];
  const normalize = value => String(value || '').trim().replace(/\s+/g, ' ').toUpperCase();
  function parseSpec(title) {
    const match = String(title).match(/^\s*(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)\s*\|\s*([+-]?\d+(?:\.\d+)?)\s*(?:mm)?\s*(?:\||$)/i);
    return match ? {size: String(Number(match[1])), width: String(Number(match[2])), offset: String(Number(match[3]))} : null;
  }
  function finishFor(title, override) {
    if (finishes.includes(override)) return override;
    const name = normalize(title).replace(/^BLACK RHINO\s+/, '');
    const centre = name.includes('/') ? name.split('/').pop() : '';
    if (/CENT(RE|ER)/.test(centre)) {
      if (/CHROME|POLISH/.test(centre)) return 'Chrome / Polished';
      if (/SILVER|MACHIN|BRUSH/.test(centre)) return 'Silver / Machined';
    }
    if (/\b(RED|BURGUNDY|MAROON|CRIMSON)\b/.test(name)) return 'Red';
    if (/\b(BLUE|COBALT)\b/.test(name)) return 'Blue';
    if (/\bBRONZE\b/.test(name)) return 'Bronze';
    if (/\b(GOLD|CHAMPAGNE)\b/.test(name)) return 'Gold';
    if (/\b(GREEN|OLIVE)\b/.test(name)) return 'Green';
    if (/\bWHITE\b/.test(name)) return 'White';
    if (/\b(SAND|TAN|DESERT)\b/.test(name)) return 'Sand / Tan';
    if (/\b(GREY|GRAY|GRAYSPACE|GUN\s?METAL|GRAPHITE|ANTHRACITE|CHARCOAL|TITANIUM)\b/.test(name)) return 'Grey / Gunmetal';
    if (/CHROME|POLISH/.test(name) && !(/LIP\s*\/.*(?:BLACK|BLK).*CENT(RE|ER)/.test(name))) return 'Chrome / Polished';
    if (/\b(BLACK|BLK|BLACKOUT)\b/.test(name)) {
      if (/MILL|MACHIN|\bMACH\b|BRUSH|CHROME|POLISH|SILVER|PLATINUM/.test(name)) return 'Black / Milled';
      return 'All Black';
    }
    if (/CHROME|POLISH/.test(name)) return 'Chrome / Polished';
    if (/SILVER|MACHIN|\bMACH\b|BRUSH|PLATINUM|ALUMIN[UI]UM/.test(name)) return 'Silver / Machined';
    return null;
  }
  function prepare(products) {
    return products.map((product, index) => ({...product, index, brand: normalize(product.brand), finish: finishFor(product.title, product.finishOverride), variants: product.variants.map(variant => ({id: variant[0], title: variant[1], price: variant[2], compare: variant[3], stock: variant[5], available: variant[6], vehicles: (variant[4] || []).map(normalize), spec: parseSpec(variant[1])}))}));
  }
  function matchVariants(product, selected, vehicle, omit) {
    if (omit !== 'brand' && selected.brand.length && !selected.brand.includes(product.brand)) return [];
    if (omit !== 'finish' && selected.finish.length && !selected.finish.includes(product.finish)) return [];
    return product.variants.filter(variant => {
      if (vehicle && !variant.vehicles.includes(normalize(vehicle))) return false;
      return ['size', 'width', 'offset'].every(field => omit === field || !selected[field].length || (variant.spec && selected[field].includes(variant.spec[field])));
    });
  }
  function filter(products, selected, vehicle, omit) {
    return products.flatMap(product => {
      const variants = matchVariants(product, selected, vehicle, omit);
      return variants.length ? [{product, variants, price: Math.min(...variants.map(variant => variant.price))}] : [];
    });
  }
  function facets(products, selected, vehicle) {
    return Object.fromEntries(fields.map(field => {
      const counts = new Map();
      for (const {product, variants} of filter(products, selected, vehicle, field)) {
        const values = field === 'brand' || field === 'finish' ? [product[field]] : variants.map(variant => variant.spec && variant.spec[field]);
        for (const value of new Set(values.filter(value => value !== null && value !== false))) counts.set(value, (counts.get(value) || 0) + 1);
      }
      for (const value of selected[field]) if (!counts.has(value)) counts.set(value, 0);
      return [field, [...counts].sort((a, b) => field === 'finish' ? finishes.indexOf(a[0]) - finishes.indexOf(b[0]) : ['size', 'width', 'offset'].includes(field) ? Number(a[0]) - Number(b[0]) : a[0].localeCompare(b[0]))];
    }));
  }
  const model = {finishes, fields, normalize, parseSpec, finishFor, prepare, matchVariants, filter, facets};
  if (typeof module !== 'undefined' && module.exports) module.exports = model;
  else root.NJTWheelModel = model;
})(typeof window === 'undefined' ? globalThis : window);
